import { useState, useEffect } from 'react'
import { api } from '../lib/api'

export type UserRole = 'facilitator' | 'trainee' | null

export function useUserRole() {
  const [role, setRole] = useState<UserRole>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function load() {
      try {
        const data = await api.getMe()
        if (!cancelled) {
          setRole(data.role as UserRole)
        }
      } catch {
        if (!cancelled) {
          setRole(null)
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    load()
    return () => { cancelled = true }
  }, [])

  return { role, loading, isFacilitator: role === 'facilitator' }
}
